import React, { useState } from "react";
import { ArrowBigUp, MessageSquare } from "lucide-react";
import { addHubComment, getHubComments, upvoteHubPost } from "@/api";
import { errMsg } from "@/hooks/useHubSession";
import { short } from "./HubCard";

export function PostItem({ p, canAct, withSession, showToast, me }) {
  const [post, setPost] = useState(p);
  const [comments, setComments] = useState(null);
  const [text, setText] = useState("");

  const vote = async () => {
    try { const r = await withSession((t) => upvoteHubPost(t, post.id)); setPost({ ...post, ...r }); }
    catch (e) { showToast(errMsg(e), "error"); }
  };
  const toggle = () => (comments ? setComments(null) : getHubComments(post.id).then(setComments));
  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      const c = await withSession((t) => addHubComment(t, post.id, text));
      setComments([...(comments || []), c]); setText(""); setPost({ ...post, comment_count: post.comment_count + 1 });
    } catch (err) { showToast(errMsg(err), "error"); }
  };

  const own = me && me.toLowerCase() === post.author;
  return (
    <div className="card-tile" data-testid={`post-${post.id}`}>
      <div className="flex gap-4">
        <button onClick={vote} disabled={!canAct || post.voted || own} data-testid={`post-upvote-${post.id}`}
          className={`flex flex-col items-center px-2 py-1 rounded-xl transition-colors ${post.voted ? "text-orange-400 bg-orange-500/10" : "text-slate-400 hover:text-orange-300 hover:bg-white/5"}`}>
          <ArrowBigUp size={22} /><span className="font-mono text-sm" data-testid={`post-upvotes-${post.id}`}>{post.upvotes}</span>
        </button>
        <div className="flex-1 min-w-0">
          <h3 className="font-display text-lg font-bold">{post.title}</h3>
          {post.body && <p className="text-sm text-slate-300 mt-1 whitespace-pre-wrap break-words">{post.body}</p>}
          <div className="mt-2 flex items-center gap-3 text-xs text-slate-500">
            <span>{short(post.author)}</span><span>{new Date(post.created_at).toLocaleString()}</span>
            <button onClick={toggle} className="flex items-center gap-1 hover:text-cyan-300" data-testid={`post-comments-toggle-${post.id}`}><MessageSquare size={13} /> {post.comment_count}</button>
          </div>
          {comments && (
            <div className="mt-3 space-y-2 border-l border-[#2A2E45] pl-3" data-testid={`post-comments-${post.id}`}>
              {comments.map((c) => <div key={c.id} className="text-sm"><span className="font-mono text-xs text-slate-500 mr-2">{short(c.author)}</span>{c.body}</div>)}
              {canAct && (
                <form onSubmit={send} className="flex gap-2">
                  <input value={text} onChange={(e) => setText(e.target.value)} maxLength={1000} placeholder="Add a comment"
                    className="flex-1 bg-[#12131C] border border-[#2A2E45] rounded-lg px-3 py-1.5 text-sm outline-none" data-testid={`post-comment-input-${post.id}`} />
                  <button className="btn-tactile btn-ghost text-xs px-3" data-testid={`post-comment-send-${post.id}`}>Send</button>
                </form>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
